const exportedObject = {
  crearAutorizacionData: {},
  crearAutorizacionLoading: false,
  crearAutorizacionError: null,

  cancelarAutorizacionData: {},
  cancelarAutorizacionLoading: false,
  cancelarAutorizacionError: null,

  getAutorizacionData: {},
  getAutorizacionLoading: false,
  getAutorizacionError: null,

  consultarAutorizacionesData: {},
  consultarAutorizacionesLoading: false,
  consultarAutorizacionesError: null,

  reactivarAutorizacionData: {},
  reactivarAutorizacionLoading: false,
  reactivarAutorizacionError: null,

  limpiarDatosAutorizacionLoading: false,

  formAutorizacionDiagnosticoData: {
    numeroBusqueda: "",
    fechaInicio: "",
    fechaFin: "",
    autorizaciones: [],
    diagnostico: "",
    diagnosticoModificar: null,
    showAlert: false,
    alertConfig: {},
    showModalModificarDiagnostico: false,
  },

  formAutorizacionDiagnosticoLoading: false,

  getAutorizacionesDiagnosticoLoading: false,

  modificarDiagnosticoDefinitivoLoading: false,

  confirmarDiagnosticoDefinitivoLoading: false,

  descargarReporteVoucherLoading: false,
  descargarReporteVoucherData: {},
};

export default exportedObject;
